import { default as app } from '../app/_default/store'
import { default as auth } from '../domain/auth/store'
import { default as leiloes } from '../domain/leiloes/store'
import { default as chat } from '../domain/chat/store'
import { default as chatPlugin } from '../plugins/chat-plugin'

export default { app, auth, leiloes, chat, chatPlugin }



// WEBPACK FOOTER //
// ./src/store/modules.js